var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Alert as SUIAlert } from '@one-thd/sui-atomic-components';
import styles from './alert.module.scss';
/* TODO: Delete this shared component when Stencil fix bug with border. */
export const Alert = (_a) => {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    return (React.createElement("div", { className: styles.alertContainer },
        React.createElement(SUIAlert, Object.assign({}, restProps), children)));
};
